module.exports = __webpack_public_path__ + "static/img/drmocode.48cf13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drmocode.png
// module id = Fwzs
// module chunks = 1